module.exports = __webpack_public_path__ + "static/media/Profile_Clicks_Icon.d0eaf937.svg";